module.exports = __webpack_public_path__ + "img/home-11.bc46f2cc.png";